import { apiClient } from '../../../../helpers/api_helper';

export const getAllCountryData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Country/GetAllCountry`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllCountryForSelect = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/Country/GetCountrySelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getCountryById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Country/GetCountryDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createCountry = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Country/InsertCountry', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateCountry = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Country/UpdateCountry', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteCountry = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Country/DeleteCountry?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};